
import store from '@/store';
import stores from '@/services/stores';
import Vue from 'vue';
export default {
  name: 'AddEditMemoModal',

  props: {
    value: { type: Boolean, required: true },
    mode: { type: String, default: 'add' },
    memo: { type: Object, default: null },
    date: String,
    hour: {
      type: String,
      default: '12:00'
    }
  },

  data() {
    const savedStores = JSON.parse(localStorage.getItem('myStores') || '[]');
    const defaultStore = savedStores.length > 0 ? savedStores[0]._id : '';

    return {
      // form properties
      form: {
        store: defaultStore, // default store from localStorage
        startDate: this.date, // default date from prop
        endDate: this.date,
        time: this.hour || '12:00',
        description: '',
        tags: []
      },
      timeOptions: [],
      storesOptions: [],
      startDatePopup: false,
      endDatePopup: false,
      selectedDate: null
    };
  },

  computed: {
    tagsOptions() {
      const t = this.$store.state.user.translate || {};
      const options = [];

      for (let i = 1; i <= 10; i += 1) {
        const key = `memo_tag_option${i}`;
        if (t[key]) {
          options.push({
            label: t[key],
            value: key
          });
        }
      }

      return options;
    },
    isDateInvalid() {
      const start = this.normalizeDate(this.form.startDate);
      const end = this.normalizeDate(this.form.endDate);

      if (!start || !end) return false;

      return new Date(end) < new Date(start);
    },

    jobRole() {
      return this.$store.state?.user?.profile?.jobRole;
    },
    dialogOpen: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    memoHint() {
      // Get the current translated string
      let text = this.$store.state.user.translate.memo_set_store_hint;

      // Check if the string contains 'Profile' (English) or 'アカウントの設定' (Japanese)
      const profileTexts = ['Profile', 'アカウントの設定'];

      profileTexts.forEach(profile => {
        if (text.includes(profile)) {
          // Replace the profile word with a clickable link
          text = text.replace(
            profile,
            `<a href="/account" class="profile-link">${profile}</a>`
          );
        }
      });

      return text;
    }
  },

  watch: {
    memo: {
      handler(newVal) {
        if (this.mode === 'edit' && newVal) {
          this.form = {
            store: newVal.store || '',
            startDate: this.normalizeDate(newVal.startDate),
            endDate: this.normalizeDate(newVal.endDate),
            time: newVal.time || '12:00',
            description: newVal.description || '',
            tags: newVal.tags || []
          };
        }
      },
      immediate: true
    },
    date(newDate) {
      if (this.mode === 'add') {
        this.form.startDate = newDate;
        this.form.endDate = newDate;
      }
    },
    value(newVal) {
      if (newVal && this.mode === 'add') {
        this.initForm();
      }
    }
  },

  created() {
    this.timeOptions = Array.from(
      { length: 24 },
      (_, i) => `${String(i).padStart(2, '0')}:00`
    );
  },

  mounted() {
    this.storesList();
    if (this.mode === 'edit' && this.memo) {
      // ensure store exists in options
      const exists = this.storesOptions.find(s => s.value === this.memo.store);
      if (!exists && this.memo.store) {
        this.storesOptions.unshift({
          label: `Unknown Store (${this.memo.store})`,
          value: this.memo.store
        });
      }
      this.form = { ...this.memo };
    }
    this.initForm();
  },

  methods: {
    normalizeDate(d) {
      if (!d) return null;

      // Case: YYYYMMDD number (edit payload)
      if (typeof d === 'number' && d > 10000000) {
        const s = d.toString();
        return `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}`;
      }

      // Case: YYYY/MM/DD
      if (typeof d === 'string' && d.includes('/')) {
        return d.replace(/\//g, '-');
      }

      // Case: already correct
      if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) {
        return d;
      }

      return null;
    },

    autoGrow(e) {
      e.target.style.height = 'auto';
      e.target.style.height = e.target.scrollHeight + 'px';
    },
    onTagSelected() {
      this.$nextTick(() => {
        if (this.$refs.tagsSelect) {
          this.$refs.tagsSelect.hidePopup();
        }
      });
    },
    initForm() {
      const savedStores = JSON.parse(localStorage.getItem('myStores') || '[]');
      const defaultStore = savedStores.length > 0 ? savedStores[0]._id : '';

      if (this.mode === 'add') {
        this.form.store = defaultStore;
        this.form.startDate = this.date;
        this.form.endDate = this.date;
        this.form.time = this.hour || '12:00';
        this.form.description = '';
        this.form.tags = [];
      } else if (this.memo) {
        console.log('this.memo', this.memo);
        this.form = { ...this.memo };
      }
    },

    close() {
      this.dialogOpen = false;
    },

    async save() {
      if (this.isDateInvalid) {
        this.$q.notify({
          type: 'negative',
          message: 'End date cannot be earlier than start date'
        });
        return;
      }
      const payload = {
        storeId: this.form.store,
        startDate: this.normalizeDate(this.form.startDate),
        endDate: this.normalizeDate(this.form.endDate),
        time: this.form.time,
        description: this.form.description,
        tags: this.form.tags.length ? this.form.tags.join(',') : ''
      };
      console.log('payload', payload);
      try {
        // Decide which API method to call
        const apiCall =
          this.mode === 'edit'
            ? stores.updateStoreAnnotation({ id: this.memo.id, ...payload })
            : stores.createStoreAnnotation(payload);

        const result = await apiCall;

        // Notify user
        this.$q.notify({
          type: 'positive',
          message:
            this.mode === 'edit'
              ? 'Memo successfully updated'
              : 'Memo successfully created'
        });
        Vue.prototype?.$mixpanel?.track(
          this.mode === 'edit' ? 'Edited memo' : 'Saved memo',
          {
            referrer: document.referrer
          }
        );
        // Inform parent component
        this.$emit('saved', {
          mode: this.mode,
          memo: result?.data || payload
        });

        // Close dialog/modal
        this.close();
      } catch (error) {
        console.error('API Error:', error);

        this.$q.notify({
          type: 'negative',
          message: 'Failed to save memo. Please try again.'
        });
      }
    },

    storesList() {
      const savedStores = JSON.parse(localStorage.getItem('myStores') || '[]');
      const vuexStores = store.getters['user/getStoresCodeNameList'] || [];
      const vuexMapped = vuexStores.map(store => ({
        label: `${store.storeCode} ${store.name}`,
        value: store.id
      }));
      this.storesOptions = vuexMapped;

      if (savedStores.length > 0) {
        const firstLocalStore = savedStores[0];
        const exists = this.storesOptions.find(
          s => s.value === firstLocalStore._id
        );
        if (!exists) {
          this.storesOptions.unshift({
            label: `${firstLocalStore.storeNumber} ${firstLocalStore.title}`,
            value: firstLocalStore._id
          });
        }
        this.form.store = firstLocalStore._id;
      }
    }
  }
};
